import { URLS } from "@/api/urls";
import { Button } from "@components/ui/button";
import {
  Card,
  CardHeader,
  CardTitle,
  CardDescription,
  CardContent,
} from "@components/ui/card";
import { Trans } from "@lingui/react/macro";
import { ExternalLinkIcon } from "lucide-react";

export default function Documentation() {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-xl">
          <Trans>Dokumentation</Trans>
        </CardTitle>
        <CardDescription>
          <Trans>
            Läs vår API-dokumentation för att lära dig hur du använder All Ears
            API.
          </Trans>
        </CardDescription>
      </CardHeader>
      <CardContent>
        <Button className="w-fit" asChild variant="outline">
          <a href={URLS.API_DOCS} target="_blank" rel="noopener noreferrer">
            <Trans>Öppna dokumentation</Trans>
            <ExternalLinkIcon />
          </a>
        </Button>
      </CardContent>
    </Card>
  );
}
